import { useAppSelector } from '../store/hooks'

const useHasPermission = (permissionName: string): boolean => {
	const permissions = useAppSelector((state) => state.auth.permissions)
	return permissions.some((permission) => permission.name === permissionName)
}

export default useHasPermission

